export default "__VITE_ASSET__33c4a828__"